import { useState } from 'react';
import { useFormikContext } from 'formik';
import { useFormFieldConfigScope } from './useFormFieldConfigScope';

/**
 * Changes the page's scope, asking first (LeaveWithoutSavingDialog) when the form has unsaved
 * changes, which the change throws away. Returns { requestScopeChange(nextScope),
 * leaveDialogProps } — spread leaveDialogProps onto a LeaveWithoutSavingDialog.
 */
export const useGuardedScopeChange = () => {
	const { changeScope } = useFormFieldConfigScope();
	const { dirty } = useFormikContext();
	const [pendingScope, setPendingScope] = useState(null);

	const requestScopeChange = (nextScope) => {
		if (dirty) {
			setPendingScope(nextScope);
		} else {
			changeScope(nextScope);
		}
	};

	return {
		requestScopeChange,
		leaveDialogProps: {
			open: Boolean(pendingScope),
			onClose: () => setPendingScope(null),
			onConfirm: () => {
				changeScope(pendingScope);
				setPendingScope(null);
			},
		},
	};
};
